module.exports = __webpack_public_path__ + "img/flash.29326e05.svg";